import { render, staticRenderFns } from "./ReassignPagePanel.vue?vue&type=template&id=7b174dc3&"
import script from "./ReassignPagePanel.vue?vue&type=script&lang=js&"
export * from "./ReassignPagePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports